import createSagaMiddleware from 'redux-saga';
import { createLogger } from 'redux-logger';
import { createStore, applyMiddleware, compose } from 'redux';

import { IS_DEV, stateTransformer } from 'utils/common';

import rootReducer from 'reducers';
import rootSaga from 'sagas';

const DEV = IS_DEV;

/*
 * Middleware & enhancers
 */
const middleware = [];

// middleware: Redux Saga
const sagaMiddleware = createSagaMiddleware();
middleware.push(sagaMiddleware);

// middleware: Redux Logger
if (DEV) middleware.push(createLogger({ stateTransformer, collapsed: true }));

const enhancers = [];

// enhancer: middleware chain
enhancers.push(applyMiddleware(...middleware));

// enhancer: Redux DevTools
if (DEV) {
  if (window.__REDUX_DEVTOOLS_EXTENSION__) {
    enhancers.push(window.__REDUX_DEVTOOLS_EXTENSION__());
  }
}

// export the created store
const store = createStore(rootReducer, compose(...enhancers));

// run the root saga
sagaMiddleware.run(rootSaga);

export default store;
